module.exports = __webpack_public_path__ + "img/window.e1ee6066.svg";